import React from "react";
import { createRoot } from "react-dom/client";
import ImageGalleryManager from "../components/photo-management/ImageGalleryManager";

const mountPhotoManagers = () => {
  const mountPoints = document.querySelectorAll(
    ".react-photo-manager-mount-point"
  );

  mountPoints.forEach((rootElement) => {
    if (
      rootElement &&
      rootElement.dataset.reactPhotoManagerMounted !== "true"
    ) {
      const {
        initialPhotos,
        listingId,
        entityName,
        collectionName,
        isCarousel,
        csrfToken,
      } = rootElement.dataset;

      let parsedInitialPhotos;
      try {
        parsedInitialPhotos = JSON.parse(initialPhotos);
      } catch (e) {
        console.error(
          `Error parsing initialPhotos JSON for ${collectionName}:`,
          e,
          initialPhotos
        );
        parsedInitialPhotos = []; // Fallback to an empty array
      }

      const root = createRoot(rootElement);
      console.log("[PhotoManager] Rendering with props:", root.render, root, {
        initialPhotos: parsedInitialPhotos,
        listingId: parseInt(listingId, 10),
        entityName,
        collectionName,
        isCarousel: isCarousel === "true",
        csrfToken,
      });

      root.render(
        <ImageGalleryManager
          initialPhotos={parsedInitialPhotos}
          listingId={parseInt(listingId, 10)}
          entityName={entityName}
          collectionName={collectionName}
          isCarousel={isCarousel === "true"}
          csrfToken={csrfToken}
        />
      );
      rootElement.dataset.reactPhotoManagerMounted = "true"; // Mark as mounted
    } else if (
      rootElement &&
      rootElement.dataset.reactPhotoManagerMounted === "true"
    ) {
      // console.log("Photo manager already mounted for:", rootElement.id);
    }
  });
};

// Mount on initial page load
document.addEventListener("DOMContentLoaded", mountPhotoManagers);

// Mount on Turbolinks load (for Rails Turbolinks)
document.addEventListener("turbolinks:load", mountPhotoManagers);

// If using Webpacker, ensure this pack is loaded, e.g., in your layout:
// <%= javascript_pack_tag 'photo_manager' %>
